(() => {
  const registrations = [];
  const find = (scope, selector) => [
    ...(scope.matches?.(selector) ? [scope] : []),
    ...scope.querySelectorAll(selector),
  ];
  const mount = (entry, scope) => {
    find(scope, entry.selector).forEach((element) => {
      if (!entry.instances.has(element)) {
        entry.instances.set(element, entry.initialize(element) || (() => {}));
      }
    });
  };
  window.WTCTheme = {
    register(selector, initialize) {
      const entry = { selector, initialize, instances: new Map() };
      registrations.push(entry);
      mount(entry, document);
    },
  };
  document.addEventListener('shopify:section:load', (event) => {
    registrations.forEach((entry) => mount(entry, event.target));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    registrations.forEach((entry) => {
      entry.instances.forEach((destroy, element) => {
        if (event.target.contains(element)) {
          destroy();
          entry.instances.delete(element);
        }
      });
    });
  });
})();
